const AboutPage = () => {
    return (
        <>
            <h1>About</h1>
            <p>This is the about page</p>
        </>
    )
}

export default AboutPage;